import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 26, height: 26, viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.4446 8.55566L8.55566 17.4446", stroke: "white", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }), /* @__PURE__ */ React.createElement("path", { d: "M17.4446 17.4446L8.55566 8.55566", stroke: "white", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgWhiteCross);
export { ForwardRef as ReactComponent };
